import React, { useState } from 'react';
import client from '../api/client';

export default function ForgotPasswordPage({ onBack }) {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone]       = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { setError('メールアドレスを入力してください'); return; }
    setLoading(true); setError('');
    try {
      await client.post('/auth/forgot-password', { email });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail ?? '送信に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={wrapStyle}>
      <div style={cardStyle}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 44, lineHeight: 1, marginBottom: 10 }}>🔑</div>
          <div style={titleStyle}>パスワードをお忘れですか？</div>
        </div>

        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div className="msg msg-success" style={{ marginBottom: 20 }}>
              登録済みのメールアドレスにリセット用リンクを送信しました。
            </div>
            <button className="btn btn-secondary" style={{ width: '100%' }} onClick={onBack}>
              ログイン画面に戻る
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div className="form-group">
              <label className="form-label">登録済みメールアドレス</label>
              <input className="form-input" type="email" placeholder="example@email.com"
                value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            {error && <div className="msg msg-error">{error}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading}
              style={{ width: '100%', padding: '12px' }}>
              {loading ? <><span className="spinner" />送信中…</> : 'リセットメールを送信'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={onBack}
              style={{ width: '100%' }}>
              ← ログインに戻る
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const wrapStyle = {
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #FF6B9D 0%, #9B5FE3 60%, #7048D4 100%)',
  padding: '16px',
};
const cardStyle = {
  background: '#fff', borderRadius: 24,
  padding: 'clamp(24px, 7vw, 44px) clamp(20px, 6vw, 40px)',
  width: '100%', maxWidth: 400,
  boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
};
const titleStyle = {
  fontFamily: "'Nunito', 'M PLUS Rounded 1c', sans-serif",
  fontSize: 20, fontWeight: 900, color: '#7048D4',
};
